import dayjs from 'dayjs';
import { ITask } from '../../interface/tasks';

export const isTaskFormChanged = (
  task: ITask | null | undefined,
  initialTask: ITask | null | undefined,
  isEditMode: boolean,
): boolean => {
  if (isEditMode) {
    const alertTimeMatches =
      (task?.alertTime ? task?.alertTime : null) === (initialTask?.alertTime ?? null);
    return (
      task?.matter?.id !== initialTask?.matter?.id ||
      task?.duration !== initialTask?.duration ||
      task?.currentSubject !== initialTask?.subject ||
      (task?.description || null) !== (initialTask?.description || null) ||
      task?.status?.id !== initialTask?.status?.id ||
      task?.priority !== initialTask?.priority ||
      dayjs(task?.dueTime).format('YYYY-MM-DD') !==
        dayjs(initialTask?.dueTime).format('YYYY-MM-DD') ||
      dayjs(task?.startTime).format('YYYY-MM-DD') !==
        dayjs(initialTask?.startTime).format('YYYY-MM-DD') ||
      !alertTimeMatches
    );
  }
  return (
    !!task?.matter?.id ||
    !!task?.currentSubject ||
    !!task?.description ||
    !!task?.duration ||
    dayjs(task?.dueTime).format('YYYY-MM-DD') !==
      dayjs(initialTask?.dueTime).format('YYYY-MM-DD') ||
    dayjs(task?.startTime).format('YYYY-MM-DD') !==
      dayjs(initialTask?.startTime).format('YYYY-MM-DD') ||
    (task?.alertTime ? task?.alertTime : null) !== (initialTask?.alertTime ?? null)
  );
};
